export default "__VITE_ASSET__B9mbWMNP__"